import { isNil, negate, pickBy, pick } from 'lodash-es';
import { useSelector } from 'react-redux';
import { pickTruthy } from '@is24at/react-utils';
import { LocalStorageKey } from '@is24at/react-enums';
import { useLocalStorage } from '@is24at/react-hooks';
import { byUser } from '@is24at/react-redux';
import { EMPTY_OBJECT } from '@is24at/react-constants';

export const DEFAULT_MESSAGE_BODY =
  'Ich möchte mich gerne beraten lassen. Bitte nehmen Sie unverbindlich mit mir Kontakt auf.';

const IS_HOME_OWNER_KEY = 'isHomeowner';

export const useFormDefaultValues = () => {
  const [locallyPersistedValues] = useLocalStorage(
    LocalStorageKey.CONTACT_REQUEST_FORM_KEY,
  );

  const {
    account: {
      billingCity,
      billingPostalCode,
      billingStreet,
      isHomeowner,
      phone,
      primaryContactFirstname,
      primaryContactLastname,
      primaryContactSalutation,
    } = EMPTY_OBJECT,
    email,
  } = useSelector<any, User>(byUser) || EMPTY_OBJECT;

  const userSyncedValues = {
    address: billingStreet,
    city: billingCity,
    email,
    firstName: primaryContactFirstname,
    isHomeowner,
    lastName: primaryContactLastname,
    phoneNumber: phone,
    salutation: primaryContactSalutation,
    zipcode: billingPostalCode,
  };

  return {
    ...pickTruthy(locallyPersistedValues),
    ...pickBy(locallyPersistedValues, negate(isNil)),
    ...pickTruthy(userSyncedValues),
    ...pickBy(pick(userSyncedValues, IS_HOME_OWNER_KEY), negate(isNil)),
    messageBody: DEFAULT_MESSAGE_BODY,
  };
};
